<div>
  <h3>Auftragsübersicht</h3>

  <div class="contract-history-box">
    @if (orderMapData.data$|async; as orderMap) {
      <table class="table whitetable">
        <tbody>
          @for (orderType of orderTypeList; track orderType) {
            <tr>
              <td>{{ orderType.name }}</td>
              <td class="right"></td>
              <td class="right"></td>
              <td class="right">
                @for (order of orderMap[orderType.type]; track order; let i = $index) {
                  <button class="btn btn-sm"
                    style="margin-left: 5px;"
                    [title]="'Übersicht für Bestellung ' + order.id + ' anzeigen'"
                    [ngClass]="orderType.clazz"
                    (click)="open(order.id, order.positions.index)">
                    <cn-order-delivery-method [size17]="true" [deliveryMethod]="order.delivery_method">
                    </cn-order-delivery-method>
                    {{ order.id }}-{{ order.positions.index + 1 }}
                    @if (order.quantity) {
                      ({{ order.quantity|money:0 }})
                    }
                  </button>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    } @else {
      <ng-template [ngTemplateOutlet]="loadingOrError.template"></ng-template>
    }

    <loading-or-error
      #loadingOrError
      [loadingWrapper]="orderMapData"
      [errorMessage]="'Bestellungen konnten nicht geladen werden'">
    </loading-or-error>

  </div>
</div>
